// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
import wixWindow from 'wix-window';

$w.onReady(function () {
	let pre_read_data = wixWindow.lightbox.getContext();
	$w("#content").text = pre_read_data.data;
});